function renderActiveFacets(htmlData) {
	const activeFacets = $('[js-form-facets-active]');
	const activeFacetsNew = $(htmlData).find('[js-form-facets-active]');
	activeFacets.empty().append(activeFacetsNew.html());
}

function renderActiveSize() {
	const activeFacetsSize = $('[js-size-switch]');
	const listGramos = activeFacetsSize.closest('[js-filter]').find('[js-size-switch-gr]');
	const listLibras = activeFacetsSize.closest('[js-filter]').find('[js-size-switch-lb]');
	sizeSwitch(activeFacetsSize, listGramos, listLibras);
}

function renderCounts(source, target) {
    const countFilterSelect = $(target).find('[js-filter-header]');
    const countFilterSelectNew = $(source).find('[js-filter-header]');

    if (countFilterSelectNew && countFilterSelect) {
    	countFilterSelect.empty().append(countFilterSelectNew.html());
    }
}

function renderFilters(htmlData, event) {
	const facetElementsNews = $(htmlData).find('[js-filter]');
	const matchesIndex = (element) => {
		const jsFilter = event ? event.target.closest('[js-filter]') : undefined;
		return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
	}
	
	const facetsToRender = Array.from(facetElementsNews).filter(element => !matchesIndex(element));
	const countsToRender = Array.from(facetElementsNews).find(matchesIndex);

	for (var i = 0; i < facetsToRender.length; i++) {
		const filterAtributes = '[js-filter][data-index="'+ facetsToRender[i].dataset.index +'"]';
		const filterSelectNew = $(htmlData).find(filterAtributes);
		const filterSelect = $('.section-collection-product-grid').find(filterAtributes);
		$(filterSelect).empty().append(filterSelectNew.html());
	}

	renderActiveFacets(htmlData);
	renderActiveSize();
	if (countsToRender) renderCounts(countsToRender, event.target.closest('[js-filter]'));
}

function renderProductGridContainer(htmlData) {
	const productGridNew = $(htmlData).find('[data-product-grid-container]');
	const productGrid = $('[data-product-grid-container]');
	$('[js-loader-section-collection]').addClass('d-none');
	productGrid.empty().append(productGridNew.html());
}

function renderProductCount(htmlData) {
	const productCountNew = $(htmlData).find('[data-product-count]');
	const productCount = $('[data-product-count]');
	$('[js-loader-section-collection]').addClass('d-none');
	productCount.empty().append(productCountNew.html());
}

function renderSectionFromFetch(url, event) {
	fetch(url)
	.then(response => response.text())
	.then((responseData) => {
		const htmlData = responseData;
		filterData = [...filterData, { htmlData, url }];
		renderFilters(htmlData, event);
		renderProductGridContainer(htmlData);
		renderProductCount(htmlData);
	});
}

function renderSectionFromCache(filterDataUrl, event) {
	const htmlData = filterData.find(filterDataUrl).htmlData;
	renderFilters(htmlData, event);
	renderProductGridContainer(htmlData);
	renderProductCount(htmlData);
}

function updateURLHash(searchParams) {
	window.history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
}

function createSearchParams(form) {
	const formData = new FormData(form);
	return new URLSearchParams(formData).toString();
}

async function searchForms(forms) {
	const arrayForms = [];
	for (var i = 0; i < forms.length; i++) {
		const form = createSearchParams(forms[i]);
		arrayForms.push(form);
	}
	return searchParams = arrayForms.join('&');
}

function renderPage(searchParams, event, updateURL = true ) {
		searchParamsPrev = searchParams;
		const sections = $('#product-grid');
		const sectionsId = sections.data('id');
		const productCount = $('[data-product-count]');
		const productGridContainer = $('[data-product-grid-container]');
		if (productCount.length > 0 || productGridContainer.length > 0) {
			$('[js-loader-section-collection]').removeClass('d-none');
		}
		for (var i = 0; i < sections.length; i++) {
			const url = window.location.pathname + '?section_id='+ sectionsId +'&'+ searchParams;
			const filterDataUrl = element => element.url === url;
			filterData.some(filterDataUrl) ? renderSectionFromCache(filterDataUrl, event) : renderSectionFromFetch(url, event);
		}
		if (updateURL) updateURLHash(searchParams);
}

var filterData = [];
var searchParamsInitial = window.location.search.slice(1);
var searchParamsPrev = window.location.search.slice(1);
/* Active cache */
window.addEventListener('popstate', function (event) {
	const searchParams = event.state ? event.state.searchParams : searchParamsInitial;
	if (searchParams === searchParamsPrev) return;
	renderPage(searchParams, null, false);
});

window.addEventListener('load',()=>{
	/* Filters desktop */
	/* -------------------------------------------------------------------------------------- */
	$('[js-form-facets]').on('input', debounce(function(event){
		event.preventDefault();
		const forms = $('[js-form-facets]');
		searchForms(forms).then(function (searchParams) {
			renderPage(searchParams, event);
		}).catch(err => console.log(err));
	},500));
	/* Filsters mobile */
	/* -------------------------------------------------------------------------------------- */
	$('[js-button-appply]').on('click', function(event) {
		event.preventDefault();
		/* Act on the event */
		var el = $(this);
		var item = $(el.attr('data-close'));
		const forms = $('[js-form-facets-mobile]');
		searchForms(forms).then(function (searchParams) {
			renderPage(searchParams, event);
			item.removeClass('active');
		}).catch(err => console.log(err));
	});
	/* Clean filters */
	/* -------------------------------------------------------------------------------------- */
	$('.section-collection-product-grid').on('click', '[js-button-remove]', function(event) {
		event.preventDefault();
		/* Act on the event */
		var el = $(this);
		var item = $(el.attr('data-close'));
		const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
		renderPage(url);
		item.removeClass('active');
	});
	/* Sorting Desktop*/
	/* -------------------------------------------------------------------------------------- */
	$('[js-form-facets]').on('click', '[js-sorting-item]', function(event) {
		event.preventDefault();
		/* Act on the event */
		var el = $(this);
		var sortValue = el.attr('data-value');
		var sortName = el.attr('data-name');
		var optionSelect = '[js-select-sort] option[value="' + sortValue + '"]';
		var contentFilters = $(this).closest('#list-sorting');
		el.closest('.c-sorting__list-item').addClass('active').siblings('.c-sorting__list-item').removeClass('active');
		$('[data-sorting-selected]').empty().text(sortName);
		$('[js-select-sort] option').removeAttr('selected');
		$(optionSelect).attr("selected", "selected");
		/* URL filters */
		const forms = $('[js-form-facets]');
		searchForms(forms).then(function (searchParams) {
			renderPage(searchParams, event);
			contentFilters.removeClass('active');
		}).catch(err => console.log(err));
	});
	/* Menu filters - Open/Close */
	/* -------------------------------------------------------------------------------------- */
	 $('[js-open-facets]').on('click', function(event) {
		event.preventDefault();
		/* Act on the event */
		var el = $(this),
			item = $(el.attr('data-open'));
		el.addClass('active');
		item.addClass('active');
		item.attr('open', 'true');
	 });
	 $('[js-close-facets]').on('click', function(event) {
		event.preventDefault();
		/* Act on the event */
		var el = $(this),
			item = $(el.attr('data-close'));
		el.removeClass('active');
		item.removeClass('active');
		item.removeAttr('open');
	});
	/* Price filter */
	/* -------------------------------------------------------------------------------------- */
	$('.section-collection-product-grid').on('click', '[js-price-filter-options]', function(event) {
	 	/* Act on the event */
	 	var el = $(this);
    	var min = el.attr('min');
    	var max = el.attr('max');
	 	el.closest('[js-filter]').find('#Filter-Precio-GTE').val(min);
	 	el.closest('[js-filter]').find('#Filter-Precio-LTE').val(max);
	 	el.trigger("change");
	});
});